import { Icon } from "@outschool/backpack";
import { faFacebook } from "@outschool/icons";
import { facebookGeneralShareUrl } from "@outschool/routes";
import React from "react";

import * as Env from "../../../shared/Env";
import { CircularShareButton } from "./CircularShareButton";

const FACEBOOK_APP_ID = Env.FACEBOOK_APP_ID;

type Props = Omit<
  React.ComponentPropsWithoutRef<typeof CircularShareButton>,
  "icon"
> & {
  url: string;
  children: React.ReactNode;
};

export function FacebookShareButton({ url, ...props }: Props) {
  return (
    <CircularShareButton
      icon={<Icon icon={faFacebook} />}
      href={facebookGeneralShareUrl(url, FACEBOOK_APP_ID)}
      {...props}
    />
  );
}
